type Sizes = "phone" | "tablet" | "desktop" | "largeDesktop"

export const screenSizes: { [key in Sizes]: number } = {
  phone: 608,
  tablet: 818,
  desktop: 1028,
  largeDesktop: 1440,
}

export const breakpoints: number[] = Object.keys(screenSizes).map(
  k => screenSizes[k] + 1
)
export const containerWidths = [576, 786, 996, 1156]

export const mediaPresets = Object.keys(screenSizes).reduce<
  { [key in Sizes]: string }
  >(
  (acc, curr) => {
    acc[curr] = `@media (min-width: ${screenSizes[curr] + 1}px)`
    return acc
  },
  {} as any
)
